import clsx from 'clsx'
import classes from '../Card.module.scss'
import PropTypes from 'prop-types'

export function CardImage({imageSrc}) {
    return (
        <div className={clsx(classes.card__content, classes["card--img"])}>
            <img src={imageSrc} alt="" />
        </div>
    )
}

CardImage.propTypes = {
    imageSrc: PropTypes.string.isRequired
}